module.exports = __webpack_public_path__ + "static/media/framerate.d42d20c7.svg";